/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IGetLkTypeResponseV2 {
  lkType: ELkType;
}

export enum ELkType {
  /** Поискун **/
  'Searcher' = 'searcher',
  /** Собственник **/
  'Homeowner' = 'homeowner',
  /** Агент **/
  'Specialist' = 'specialist',
  /** Застройщик новостроек **/
  'Builder' = 'builder',
  /** Строительная компания загородки **/
  'SuburbanBuilder' = 'suburbanBuilder',
}
